import { jsx as _jsx } from "react/jsx-runtime";
import { Global } from "@emotion/react";
import { fontFaceLabGrotesque400NormalWoff2, fontFaceLabGrotesque500NormalWoff2, fontFaceLabGrotesque700NormalWoff2, fontFaceNotoSansSc400NormalWoff2, fontFaceNotoSansSc500NormalWoff2, fontFaceNotoSansSc700NormalWoff2, fontFaceNotoSansArabic400NormalWoff2, fontFaceNotoSansArabic500NormalWoff2, fontFaceNotoSansArabic700NormalWoff2, fontFamilyFraktion400NormalOtf, fontFamilyFraktion700NormalOtf, } from "@airhelp/design-tokens";
const fontStyles = `
@font-face {
  font-family: "Lab Grotesque";
  src: url("${fontFaceLabGrotesque400NormalWoff2}") format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: fallback;
}
@font-face {
  font-family: "Lab Grotesque";
  src:  url("${fontFaceLabGrotesque500NormalWoff2}") format("woff2");
  font-weight: 500;
  font-style: normal;
  font-display: fallback;
}
@font-face {
  font-family: "Lab Grotesque";
  src:  url("${fontFaceLabGrotesque700NormalWoff2}") format("woff2");
  font-weight: 700;
  font-style: normal;
  font-display: fallback;
}
@font-face {
  font-family: 'Noto Sans SC';
  src: url("${fontFaceNotoSansSc400NormalWoff2}") format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: fallback;
}
@font-face {
  font-family: 'Noto Sans SC';
  src: url("${fontFaceNotoSansSc500NormalWoff2}") format('woff2');
  font-weight: 500;
  font-style: normal;
  font-display: fallback;
}
@font-face {
  font-family: 'Noto Sans SC';
  src: url("${fontFaceNotoSansSc700NormalWoff2}") format('woff2');
  font-weight: 700;
  font-style: normal;
  font-display: fallback;
}
@font-face {
  font-family: 'Noto Sans Arabic';
  src: url("${fontFaceNotoSansArabic400NormalWoff2}") format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: fallback;
}
@font-face {
  font-family: 'Noto Sans Arabic';
  src: url("${fontFaceNotoSansArabic500NormalWoff2}") format('woff2');
  font-weight: 500;
  font-style: normal;
  font-display: fallback;
}
@font-face {
  font-family: 'Noto Sans Arabic';
  src: url("${fontFaceNotoSansArabic700NormalWoff2}") format('woff2');
  font-weight: 700;
  font-style: normal;
  font-display: fallback;
}

@font-face {
  font-family: 'PP Fraktion Sans';
  src: url("${fontFamilyFraktion400NormalOtf}") format('opentype');
  font-weight: 400;
  font-style: normal;
  font-display: fallback;
}
@font-face {
  font-family: 'PP Fraktion Sans';
  src: url("${fontFamilyFraktion700NormalOtf}") format('opentype');
  font-weight: 700;
  font-style: normal;
  font-display: fallback;
}
`;
const Fonts = () => _jsx(Global, { styles: fontStyles });
export { Fonts, fontStyles };
